import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const isAuthenticated = useSelector(
    (state) =>
      state.communityData && Object.keys(state.communityData).length > 0
  );

  return isAuthenticated ? <Navigate to="/" /> : children;
};

export default PublicRoute;
